<template>
  <AiChat :open="visible" ref="aiChat" :quote="{
    type: 'aichat.hint',
    name: `${formData.name}-语音${~~insertConf.index + 1}`,
    workId: 'OPTIMIZE_CALL_SCRIPT',
    hint: `节点名称:${formData.name}\n节点文本:${formData.voices && formData.voices[insertConf.index] && formData.voices[insertConf.index].text}`
  }" @on-close="commonCancel" @on-insert="onInsert" :title="nodeDetail && nodeDetail.id ? '编辑普通节点' : '增加普通节点'">
    <div class="common-container">
      <Form class="form-content" style="width: 100%" :model="formData" ref="form" :label-width="110" :rules="ruleValidate">
        <FormItem label="节点名称" prop="name">
          <Input v-model="formData.name" style="width: 300px" placeholder="" />
        </FormItem>
        <FormItem v-show="formData.name === '开场白'" label="动态开场白">
          <i-switch :disabled="formData.name !== '开场白'" v-model="formData.is_multi_prologue_node"/>
        </FormItem>
        <form-item-voices
          :disabled="formData.is_multi_prologue_node"
          label="话术文本"
          v-model="formData.voices"
          :formItemProps="{
            rules: {required: true, message: '话术文本不能为空', trigger: 'blur'},
          }"
          @openAi="(index) => {
            openAi('confirm_voice', index)
          }"
        />
        <form-item-outs v-model="formData.outs" :formItemProps="{ prop: 'outs' }"/>
        <!-- 是否支持打断 -->
        <form-item-can-break :formItemProps="{ prop: 'can_break' }" v-model="formData.can_break"/>
        <FormItem label="前">
          <InputNumber v-model="formData.break_delay" :min="0"  :disabled="!formData.can_break"/><span style="margin-left: 5px">ms不打断</span>
        </FormItem>
        <!-- <FormItem label="跳转回节点播报设置" style="margin-bottom: 0;">
          <i-switch v-model="formData.is_replay_threshold"/>
          <Tooltip max-width="300" content="若话术播报中途跳出节点后再返回，系统将判断跳转前的播报时长：若已超过设定值，则不再重复播报节点话术，而是静默等待客户回复，并依据回复内容决定后续流走向向。" placement="top">
            <Icon style="margin-left: 5px;" type="ios-help-circle-outline" />
          </Tooltip>
        </FormItem> -->
        <!-- <div v-if="formData.is_replay_threshold" style="line-height: 1.8; background: #f5f7fa; padding: 12px 16px; border-radius: 4px; margin-bottom: 24px;">
          <span>如果节点音频播报时长大于等于</span>
          <InputNumber
            v-model="formData.replay_threshold"
            :min="0"
            style="width: 70px; margin: 0 5px;"
            placeholder="0"
          />
          <span>ms，那么再次返回此节点时，将不再播放该音频。若未达到配置条件，且节点存在多个语音，则循环播放。</span>
        </div> -->
        <FormItem label="延迟播放">
          <InputNumber v-model="formData.playback_delay" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="协同提醒">
          <div>
            <i-switch v-model="formData.hmc_remind"/>
            <span style="margin-left: 15px;" v-if="formData.hmc_remind">
              <SkillSelect v-model="formData.hmc_skill_id" v-if="access.userSkill"/>
            </span>
          </div>
        </FormItem>
        <FormItem label="说完转接">
          <i-switch v-model="formData.hmc_after_play" :disabled="!formData.hmc_remind"/>
        </FormItem>
        <FormItem label="启用按键">
          <i-switch v-model="formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="收号长度">
          <InputNumber v-model="formData.dtmf_digits_length" :min="0" placeholder="收号长度 0-不限制" :disabled="!formData.enable_dtmf" />
        </FormItem>
        <FormItem label="收号终止字符" prop="dtmf_terminator">
          <Input v-model="formData.dtmf_terminator"  :disabled="!formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="等待响应超时时长">
          <InputNumber v-model="formData.input_timeout" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="播放超时语音">
          <i-switch :value="!formData.no_timeout_voice" @on-change="formData.no_timeout_voice = !$event"/>
        </FormItem>
        <form-item-tag :formItemProps="{ prop: 'tag' }" v-model="formData.tag"/>
        <form-item-var :formItemProps="{ prop: 'vars' }" v-model="formData.vars"/>
      </Form>
      <div class="btn">
        <Button style="margin-right: 20px" color="#547ed1" @click="commonCancel">取消</Button>
        <Button
          type="primary"
          style="margin-right: 20px"
          color="#547ed1"
          @click="submitCommon"
          >确定</Button
        >
      </div>
    </div>
  </AiChat>
</template>
<script>
import FormItemVar from '@/components/FormItemVar.vue';
import FormItemTag from '@/components/FormItemTag.vue';
import cloneDeep from 'lodash/cloneDeep'
import FormItemVoices from '../../../components/FormItemVoices.vue';
import FormItemCanBreak from '../../../components/FormItemCanBreak.vue';
import FormItemOuts from '../../../components/FormItemOuts.vue';
import SkillSelect from '../../../components/SkillSelect.vue';
import { addNodeId } from '@/utils/nodeIdPool';
import AiChat from '@/views/aiChat/index'
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: ['visible', 'nodeDetail'],
  components: {
    FormItemVar,
    FormItemTag,
    FormItemVoices,
    FormItemCanBreak,
    FormItemOuts,
    SkillSelect,
    AiChat
  },
  data() {
    const validatedtmfTerminator = (rule, value, callback) => {
        if(value === '') {
          callback()
        } else if (value.lenth > 1) {
            callback(new Error('只支持1位'))
        } else if (!['0','1','2','3','4','5','6','7','8','0','*','#'].includes(value)) {
            callback(new Error('只支持0-9、*、#'))
        } else {
            callback()
        }
    }
    return {
      showBranchModal: false,
      formData: {
        name: '',
        is_multi_prologue_node: false,
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        is_replay_threshold: false,
        replay_threshold: 0,
        hmc_after_play: false,
        input_timeout: 0,
        no_timeout_voice: false,
				tag: '',
        outs: [{ intent_id: 'I00002' }, { intent_id: 'I00003' }, { intent_id: 'I00001' }, { intent_id: '_knowledge' }],
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
          // '/mnt/robot/record/scene/560f5db7-cdd8-4209-82b9-7951041423e3.wav', 
				vars: [],
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      },
      ruleValidate: {
        name: [
          { required: true, message: '节点名不能为空', trigger: 'blur' },
        ],
        dtmf_terminator: [
          { validator: validatedtmfTerminator },
        ],
      },
      insertConf: {
        type: '',
        index: 0,
      },
    };
  },
	computed: {
    ...mapState('user', [
      "access"
    ]),
	},
	watch: {
		nodeDetail(val) {
			if (!val) {
        this.resetFormData();
        return;
      }
      const formData = {
        ...this.formData,
        ...cloneDeep(val),
        is_replay_threshold: !!val.replay_threshold
      }
      formData.voices = formData.voices.filter(item => item.text || item.voice)
      // 如果没有知识库出口，则添加
      let isKnowledge = false;
      if (!formData.outs) formData.outs = [];
      for (const out of formData.outs) {
        if (out.intent_id === '_knowledge') {
          isKnowledge = true;
          break;
        }
      }
      if (!isKnowledge) {
        formData.outs.push({ intent_id: '_knowledge' })
      }
      this.formData = formData;
		}
	},
  methods: {
    submitCommon() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = {
          ...cloneDeep(this.formData),
          hmc_skill_id: this.formData.hmc_remind ? this.formData.hmc_skill_id : '',
          type: 'play',
          replay_threshold: this.formData.is_replay_threshold ? this.formData.replay_threshold : 0,
        }
        delete formData.is_replay_threshold;
        // 把未匹配放到最后
        formData.outs.sort((_, out) => {
          return out.intent_id === '_miss' ? -1 : 1
        })
        if(this.formData.id) {
          this.$emit('editCommonNode', formData)
        } else {
          this.$emit('addCommon', formData)
        }
        this.commonCancel();
      })
    },
    commonCancel() {
      try {
        this.resetFormData();
      } catch (error) {
        // 改成多段录音后 form.resetFields 后报错
        console.log('error :>> ', error);
      }
      this.$emit('change', false)
      this.$emit('cancel');
      this.insertConf = {
        type: '',
        index: 0,
      }
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        is_multi_prologue_node: false,
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        is_replay_threshold: false,
        replay_threshold: 0,
        hmc_after_play: false,
        input_timeout: 0,
        no_timeout_voice: false,
				tag: '',
        outs: [{ intent_id: 'I00001' }, { intent_id: 'I00002' }, { intent_id: 'I00003' }, { intent_id: '_knowledge' }],
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
				vars: [],
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      }
    },
    openAi(type, index) {
      this.insertConf = {
        type,
        index
      }
      setTimeout(() => {
        this.$refs.aiChat.sendMessage('文案优化')
      }, 100)
    },
    onInsert(text) {
      const { index } = this.insertConf
      this.formData.voices[index].text = text;
    },
  },
};
</script>
<style lang="scss" scoped>
.common-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.form-content {
  overflow-y: auto;
  flex: 1;
}
.btn {
  width: 100%;
  background: #fff;
  padding: 10px 16px;
  text-align: right;
	border-top: 1px solid #e8e8e8;
}
.right {
  width: 300px;
}
</style>